import {
  SUBSCRIPTION_DETAILS_ARE_FETCHING,
  SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS,
  SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR,
  SUBSCRIPTION_DETAILS_CLEAR,
} from "./../../../constants/actionTypes/actionTypes";
const initialState = {
  data: [],
  isFetching: false,
  hasFetched: false,
  error: null,
};

// next line is excluded from a sonar because an order of variables is provided by redux
// prettier-ignore
const userSubscriptionDetails = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case SUBSCRIPTION_DETAILS_ARE_FETCHING:
      return {
        ...state,
        isFetching: true
      };
    case SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        hasFetched: true
      };
    case SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR:
      return {
        ...state,
        isFetching: false,
        hasFetched: false,
        error: action.error
      };
    case SUBSCRIPTION_DETAILS_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default userSubscriptionDetails;
